import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import axios from 'axios';
import Home from './pages/Home';
import Booking from './pages/Booking';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import './App.css';

function App() {
  const [settings, setSettings] = useState(null);
  const [theme, setTheme] = useState('classic');

  useEffect(() => {
    fetchSettings();
  }, []);

  useEffect(() => {
    if (settings) {
      document.title = settings.company_name || 'Car Detailing';
    }
  }, [settings]);

  const fetchSettings = async () => {
    try {
      const response = await axios.get('/api/settings');
      setSettings(response.data);
      setTheme(response.data.theme || 'classic');
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  if (!settings) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Router>
      <div className={`App theme-${theme}`}>
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-logo">{settings.company_name}</Link>
            <ul className="nav-menu">
              <li className="nav-item">
                <Link to="/" className="nav-link">Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/booking" className="nav-link">Booking</Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link">Contact</Link>
              </li>
            </ul>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<Home settings={settings} />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact settings={settings} />} />
          <Route path="/admin" element={<Admin onSettingsUpdate={fetchSettings} />} />
        </Routes>

        <footer className="footer">
          <div className="footer-content">
            <p>&copy; {new Date().getFullYear()} {settings.company_name}. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
